<template>
  <div class="container ma-auto">
    <vx-card title="Details">
      Payment can be made online or bank transfer. Payment mode details are as follows:
      <ul class="font-semibold ml-2">
        <li>Account Name: Cyrus Creative Solutions Sdn.Bhd</li>
        <li>Account Number: 5147-2168-4773</li>
        <li>Bank Name: May Bank</li>
        <li>SWIFT Code: MBBEMYKL</li>
        <li>Bank Branch: Plaza Crystalville, 21 & 23, Jalan 23/70a, Desa Sri Hartamas, 50480 Kuala Lumpur.</li>
      </ul>
      <p class="mt-2">Kindly email the proof of payment to info@ira-lex.com</p>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: "Payment"
}
</script>

<style scoped>

</style>
